export const IG_URL = 'https://www.instagram.com/';
export const IG_HASHTAG_URL = 'https://www.instagram.com/explore/tags/';
export const MP_URL = 'https://wixmp-19e700b7666f74a00729a0dd.wixmp.com/';
export const PARASTORAGE_URL =
  'https://static.parastorage.com/services/instagram-blocks-app/1.462.0/assets/templates/';
export const SCHEMA_FILENAME = 'template_scema.json';
// export const TMPLT_SCHEMA_URL = `${MP_URL}/${SCHEMA_FILENAME}`;
// export const LOCAL_HOST_TEMPLATES = 'https://localhost:3200/assets/templates/';
